import {NavLink} from "react-router-dom";
import {useState} from "react";
import {useT} from "../i18n/i18n";

const NAV_ITEMS = [
    {to: "/home", labelKey: "nav.home"},
    {to: "/about", labelKey: "nav.about"},
    {to: "/services", labelKey: "nav.services"},
    {to: "/portfolio", labelKey: "nav.portfolio"},
    // {to: "/projects", labelKey: "nav.projects"},
    // {to: "/contacts", labelKey: "nav.contacts"},
];

export default function Navbar({language, setLanguage, isHomePage = false}) {
    const {t} = useT(language);
    const [menuOpen, setMenuOpen] = useState(false);
    const isEnglish = language === "en";

    return (
        <header className="py-4 sm:py-6 border-b border-black/10 dark:border-white/15 w-full overflow-x-hidden">
            <div className="flex items-center justify-between gap-3 sm:gap-4 min-w-0">
                <NavLink to="/home" className="shrink-0 flex items-center gap-2 sm:gap-3 min-w-0 hover:opacity-80 transition-opacity group">
                    {/* Brand and tagline */}
                    <div className="shrink-0 flex flex-col gap-0.5 min-w-0">
                        <div className={`font-extrabold tracking-wide leading-none text-[14px] sm:text-[18px] ${
                            isHomePage 
                                ? "text-[rgb(var(--app-fg))]" 
                                : "text-black"
                        } truncate`}>
                            {t("nav.brand")}
                        </div>
                        <div className={`text-[9px] sm:text-[11px] font-medium tracking-widest ${
                            isHomePage 
                                ? "text-[rgb(var(--app-muted))]" 
                                : "text-black/60"
                        } uppercase truncate`}>
                            {t("nav.tagline")}
                        </div>
                    </div>
                </NavLink>

                <nav aria-label="Primary" className="hidden md:flex flex-1 justify-center">
                    <ul className="flex items-center gap-7 leading-none">
                        {NAV_ITEMS.map((item) => (
                            <li key={item.to}>
                                <NavLink to={item.to} className={({isActive}) =>
                                        isActive
                                            ? isHomePage
                                                ? "relative font-semibold text-white after:absolute after:left-0 after:-bottom-2 after:h-[2px] after:w-full after:bg-[#E19F3B]"
                                                : "relative font-semibold text-black after:absolute after:left-0 after:-bottom-2 after:h-[2px] after:w-full after:bg-[#E19F3B]"
                                            : isHomePage
                                                ? "text-white/70 hover:text-white"
                                                : "text-black/70 hover:text-black"}>
                                    {t(item.labelKey)}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="shrink-0 flex items-center gap-2 sm:gap-3">
                    <button type="button"
                        onClick={() => setLanguage(isEnglish ? "it" : "en")}
                        className={`h-9 sm:h-10 border px-2 sm:px-3 text-xs sm:text-sm rounded-md ${
                            isHomePage
                                ? "border-black/15 dark:border-white/20 bg-white/60 dark:bg-white/5 hover:bg-black/5 dark:hover:bg-white/10 text-white"
                                : "border-black/15 bg-white/60 hover:bg-black/5 text-black"
                        } transition-colors whitespace-nowrap`}
                        aria-label={isEnglish ? t("nav.switchToItalianAria") : t("nav.switchToEnglishAria")}>
                        {isEnglish ? t("nav.localeIt") : t("nav.localeEn")}
                    </button>

                    <button type="button"
                        className={`md:hidden h-9 sm:h-10 text-lg border px-2 sm:px-3 rounded-md ${
                            isHomePage
                                ? "border-black/15 dark:border-white/20 bg-white/60 dark:bg-white/5 text-white"
                                : "border-black/15 bg-white/60 text-black"
                        } flex-shrink-0`}
                        aria-label={t("nav.toggleMenuAria")} aria-expanded={menuOpen} aria-controls="nav-menu"
                        onClick={() => setMenuOpen(!menuOpen)}>
                        {"\u2630"}
                    </button>
                </div>
            </div>

            <nav id="nav-menu" aria-label="Mobile primary" hidden={!menuOpen} className={`md:hidden mt-4 overflow-x-hidden rounded-lg border ${
                isHomePage
                    ? "bg-white/5 backdrop-blur-sm border-white/20"
                    : "bg-black/5 border-black/20"
            } p-4`}>
                <ul className="flex flex-col gap-3">
                    {NAV_ITEMS.map((item) => (
                        <li key={item.to}>
                            <NavLink to={item.to} onClick={() => setMenuOpen(false)}
                                className={({isActive}) =>
                                    isActive
                                        ? isHomePage
                                            ? "block font-semibold text-white bg-white/10 px-3 py-2.5 rounded-md border-l-2 border-[#E19F3B] transition-all"
                                            : "block font-semibold text-black bg-black/10 px-3 py-2.5 rounded-md border-l-2 border-[#E19F3B] transition-all"
                                        : isHomePage
                                            ? "block text-white/80 hover:text-white px-3 py-2.5 rounded-md transition-colors"
                                            : "block text-black/80 hover:text-black px-3 py-2.5 rounded-md transition-colors"}>
                                {t(item.labelKey)}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>
        </header>
    );
}

